import { Plugin, PluginKey } from "prosemirror-state";

export const uniqueIdsKey = new PluginKey("uniqueIds");

export const uniqueIds = new Plugin({
  key: uniqueIdsKey,
  state: {
    init(config, instance) {
      const { doc } = instance,
        currentIds = scanIds(doc);

      return { ids: currentIds };
    },
    apply(tr, value, oldState, newState) {
      return { ids: scanIds(oldState.doc) };
    }
  },
  appendTransaction: (transactions, oldState, newState) => {
    if(!transactions.some(tr => tr.docChanged)) {
      return null;
    }

    let modified = false;
    const ids = scanIds(oldState.doc),
      idsTally = {},
      //conflictiveNodes = [],
      { tr } = newState;

    for(const key of ids) {
      idsTally[key] = 0;
    }

    //transactions.forEach(transaction => {
      //transaction.steps.forEach((step, index) => {
        //const mapping = transaction.mapping.slice(index);
        //step.getMap().forEach((oldStart, oldEnd, newStart, newEnd) => {
          //if(newStart === newEnd) {
          //  return;
          //}

          //try {
            newState.doc.descendants((node, pos) => {
              if(!!node.attrs.id) {
                const { id } = node.attrs;
                if(idsTally[id] >= 1) {
                  tr.setNodeMarkup(pos, null, { ...node.attrs, id: null });
                  modified = true;
                } else {
                  idsTally[id] += 1;
                }
              }
            });
          //} catch(_) {
          //  return;
          //}
        //});
      //});
    //});

    return modified ? tr : null;
  }
});

function scanIds(doc) {
  const ids = new Set();
  doc.descendants((node) => {
    if(!!node.attrs.id) {
      ids.add(node.attrs.id);
    }
  });

  return ids;
}